export default __webpack_public_path__ + "static/media/Main Guit_1.81dd3031.wav";